import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const LEGAL_AGE = 18;

export const isOver18YearsOld = (date: string) => {
  const currentAgeExtractedFromDate = dayjs().diff(dayjs(date, 'YYYY-MM-DD'), 'year');

  return currentAgeExtractedFromDate >= LEGAL_AGE;
};

export const isValidPartialDateInThePast = (date: string) => {
  const daysInPast = dayjs().diff(dayjs(date, 'YYYY-MM'), 'day');

  return daysInPast >= 0;
};

export const isValidDateInTheFuture = (date: string | Date) => dayjs().isBefore(date, 'day');

export const isValidPartialDateBefore = (date: string, beforeDate: string) => {
  const daysInPast = dayjs(beforeDate, 'YYYY-MM').diff(dayjs(date, 'YYYY-MM'), 'day');

  return daysInPast >= 0;
};

export const isValidDate = (date: string) => dayjs(date, 'YYYY-MM-DD').isValid();
